<template>
  <div class="grid-container containerV2" :class="classes">
    <h4 v-if="title" class="title">{{ title }}</h4>
    <div ref="grid" class="homepage-block-grid">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomepageGrid",
  props: {
    title: {
      type: String,
      default: null,
    },
    noContainer: {
      type: Boolean,
      default: false,
    },
    backgroundColour: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "grid-container--noContainer": this.noContainer,
        "grid-container--backgroundColour": this.backgroundColour,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  padding: 40px 20px;

  @include respond-above(md) {
    padding: 60px 40px;
  }

  &--noContainer {
    margin: 0;
    padding: 0;

    .homepage-block-grid {
      grid-row-gap: 0;

      @include respond-above(md) {
        column-gap: 0;
      }
    }
  }
  &--backgroundColour {
    background-color: $color-grey-lightest;
  }
}

.homepage-block-grid {
  display: grid;
  grid-row-gap: 40px;

  @include respond-above(md) {
    column-gap: 40px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.title {
  text-align: center;
  @include editorial-body(16px);
  font-style: italic;
  line-height: 150%;
  margin-bottom: 40px;

  @include respond-above(md) {
    margin-bottom: 60px;
  }
}
</style>
